import { Beneficiario } from "../../../../interfaces/entities/Beneficiario"
import { Conta, DadosContaBeneficiario, LstDadosContasCadastradas } from "../../../../interfaces/entities/Reembolso/DadosContaBeneficiario"
import { Ouvidor } from "../../../../interfaces/entities/Reembolso/Ouvidor"
import { Dados } from "../../../../interfaces/props/Financeiro/Reembolso/ReembolsoPadrao"

export const defaultReembolsoPadrao: Dados = {
    passo1: {
        informativo: [],
        descrCheckBox: '',
        infoBotao: ''
    },
    passo2: {
        descricao: ''
    },
    passo3: {
        informativoInicialPasso3: '',
        descrCheckBoxPasso3: '',
        lstConteudo: []
    }
}

export const defaultOuvidor: Ouvidor = {
    idPedidoReembolso: 0,
    idUsrContrReembolso: 0,
    tipoDocto: '',
    numDocto: '',
    nomeProfissional: '',
    idCidade: '',
    idUf: '',
    numProtocolo: ''
}

export const defaultDadosContaBeneficiario: DadosContaBeneficiario = {
    lstBanco: [],
    lstTipoConta: [],
    lstDadosContasCadastradas: []
}

export const defaultAccount: LstDadosContasCadastradas = {
    idCadContaReembolso: '',
    nomeTitularConta: '',
    idPessoa: '',
    indClassifConj: '',
    cpfTitularConta: '',
    numBanco: '',
    banco: '',
    agencia: '',
    numConta: '',
    digConta: '',
    indTipoConta: '',
    descrTipoConta: '',
    dtCad: '',
    dtInicValidade: '',
    dtFimValidade: '',
    idPessoaDependente: 0
}

export const defaultBenef: Beneficiario = {
    status: '',
    idOperador: '',
    idOperadorCoop: '',
    idPessoa: '',
    idade: '',
    idUsrContr: 0,
    indObrigatorioTrocarSenha: '',
    nome: '',
    sobrenome: '',
    login: '',
    crm: '',
    email: '',
    tel: '',
    cel: '',
    cpf: '',
    dtExpiracao: '',
    tipoOperador: '',
    tipoUsr: '',
    tipoPessoaContr: '',
    titularPagador: '',
    idPessoaPagador: '',
    idContr: '',
    indAcessoBoletoDigital: '',
    indAtualizaEnderPostal: '',
    indRecebido: '',
    telRecebido: '',
    siteRecebido: '',
    nomePessoaRecebido: '',
    acessaCobrancaHonorario: '',
    acessaRegistrarHorario: '',
    indClienteMais: '',
    indPermitePAVirtual: '',
    indPermiteTelemedicina: '',
    indPermiteSaudeEmocional: '',
    indPermiteProdExecutivo: '',
    indPermiteReembolso: '',
    indPermiteReembolsoPadrao: '',
    indPermiteMeusBeneficiaios: '',
    indPermisOstomia: '',
    idMedicoReferencia: '',
    nomeMedicoReferencia: '',
    acessoIndicadoresTeleMedicina: '',
    acessoNavegar: '',
    indStatusBenef: false,
    idEmpresa: 0,
    indBioFacial: '',
    indPermisBioFacial: '',
    dtAberturaAGO: '',
    dtLimiteEntradaAGO: '',
    labelBtnAGO: '',
    produto: {
        idProduto: 0,
        descricaoProduto: '',
    },
}

export const defaultAccountsOptions: Conta[] = [
    {id: 'C', descricao: 'Conjunta'},
    {id: 'I', descricao: 'Individual'}
]